"use strict";

var CatalogEntry = require('./CatalogEntry');

function getProductCatalogInformation(product, _ref) {
  var productSettings = _ref.productSettings,
      catalog = _ref.catalog;
  var constructor = product.type;

  if (productSettings[constructor]) {
    var _productSettings$cons = productSettings[constructor],
        name = _productSettings$cons.name,
        category = _productSettings$cons.category,
        fallback = _productSettings$cons.fallback;
    var catalog_name;
    var catalog_category;

    if (name) {
      if (name.match(/\${([a-z_]*)}/)) {
        // e.g. we can put in the settings "name": "${design_name} Wedding Signs"
        // and replace it with product.design_name.
        var matcher = name.match(/\${([a-z_]*)}/);
        var new_name = name.replace(matcher[0], product[matcher[1]]);
        catalog_name = new RegExp(new_name);
      } else {
        catalog_name = new RegExp(name);
      }
    } else {
      catalog_name = new RegExp(product.design_name);
    }

    if (category) {
      catalog_category = new RegExp(category);
    } else {
      // should be a fall-back only
      catalog_category = new RegExp(product.product_type);
    }

    var catalog_entries = catalog.filter(function (item) {
      return item.name.match(catalog_name) && item.category.match(catalog_category);
    });

    if (catalog_entries.length >= 1) {
      return new CatalogEntry(catalog_entries[0]);
    }

    if (fallback) {
      return new CatalogEntry({
        images: [fallback]
      });
    }
  }

  if (productSettings["default"] && productSettings["default"].fallback) {
    return new CatalogEntry({
      images: [productSettings["default"].fallback]
    });
  }

  throw new Error('No Default Found'); // return new CatalogEntry();
}

module.exports = getProductCatalogInformation;